import "babel-polyfill"; // 解决Ie9
import Vue from "vue";

import store from "./store/index";
// import "./element";
import * as filters from "./filtres/index"; // 全局过滤器
import "./role"; // 权限
import "./assets/icons/iconfont";
import IconSvg from "./components/common/IconSvg.vue"; // svg组件

import "./utils/directives.js";
import ELEMENT from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ELEMENT, {
    size: 'small',
});
import App from "./App.vue";
import router from "./router/index";
// 注册全局组件（register global）
Vue.component("icon-svg", IconSvg);
import {getmbcountAll} from "./api/product/product";
getmbcountAll().then((res) => {
    let country=[]
    res.data.forEach(item=>{
        country.push({
            name:item.name,
            id:item.id,
            checked:false
        })
    })
    sessionStorage.setItem('opencountry',JSON.stringify(country))
    //这个缓存用于商品添加/修改选择国家使用
});
// 注册全局实用程序过滤器（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
//表单验证
import Validate from "@/utils/filter_rules";
Vue.use(Validate);
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
